<template>

  <div class="container-fluid" >

    <div class="row mb-2">

      <div class="col-6">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>موجودی کالا در تمام انبارها</span>
            </div>
          </div>
          <input
            v-model="productName"
            type="text"
            class="form-control"
            @click="openProductModal"
            placeholder="ابتدا کالا را انتخاب کنید"
            readonly
          >
          <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
        </div>
      </div>
      <div class="col-6 text-left">
        <button class="btn btn-info" @click="onPrintClicked"><i class="fa fa-print"></i></button>
      </div>
    </div>
    <div class="row my-2 text-center" v-if="nodata">
      <div class="col-12 mt-3">
        <h5>موجودی ثبت نشده است</h5>

      </div>
    </div>
    <div class="row my-2" v-else  id="printMe">
      <div class="col-12 mt-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">نام محصول</th>
            <th scope="col" class="text-center">واحد</th>
            <th scope="col" class="text-center">نام کارگاه</th>
            <th scope="col" class="text-center">موجودی انبار</th>
            <th scope="col" class="text-center">مجموع ارزش کالا</th>
            <th scope="col" class="text-center">آخرین قیمت</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in productQuantity">
            <!--<th scope="row" class="text-center">{{item.id}}</th>-->
            <td class="text-center">{{productName}}</td>
            <td class="text-center">{{unitName}}</td>
            <td class="text-center">{{item.companyName}}</td>
            <td class="text-center">{{item.quantity}}</td>
            <td class="text-center">{{item.price.toLocaleString()}}</td>
            <td class="text-center">{{item.lastPrice.toLocaleString()}}</td>
            <!--<td class="text-center"> <button @click="showProgramDetail(item.productId)" class="btn iconed btn-success"><i-->
            <!--class="icon-file-document-box-multiple"></i><span></span></button></td>-->
          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <hr/>
    <h5>موجودی مواد اولیه در کل شرکت</h5>
    <small>مواد اولیه: کالاهایی که کالای میانی ندارند و خود کالای میانی هستند</small>

    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <b-tab title="موجودی مواد اولیه در کل شرکت" active>
        <div class="row my-4">
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">موجودی در کل شرکت</th>
                <th scope="col" class="text-center">واحد</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in rawproductQuantity">
                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.totalQuantity}}</td>
                <td class="text-center">{{item.unitName}}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="موجودی مواد اولیه به تفکیک کارگاه">
        <div class="row my-4">
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">موجودی در کل شرکت</th>
                <th scope="col" class="text-center">واحد</th>
                <th scope="col" class="text-center">موجودی کارگاه ها</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in rawproductQuantity">
                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.totalQuantity}}</td>
                <td class="text-center">{{item.unitName}}</td>
                <td v-if="item.companyQuantitys == null">
                  <h6 class="text-center">موجودی ثبت نشده است</h6>
                </td>
                <td v-else>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">نام کارگاه</th>
                      <th scope="col" class="text-center">موجودی انبار</th>
                      <th scope="col" class="text-center">مجموع ارزش کالا</th>
                      <th scope="col" class="text-center">آخرین قیمت</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, index) in item.companyQuantitys">
                      <td class="text-center">{{it.companyName}}</td>
                      <td class="text-center">{{it.quantity}}</td>
                      <td class="text-center">{{it.price.toLocaleString()}}</td>
                      <td class="text-center">{{it.lastPrice.toLocaleString()}}</td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

        <div class="col-lg-12 col-12 my-5">
          <div class="card shadow text-white  mb-1">
            <div class="card-body pb-0">
              <div class="card-chart">
                <canvas id="product-company-chart" width="1200" height="400"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-12 my-5">
          <div class="card shadow text-white  mb-1">
            <div class="card-body pb-0">
              <div class="card-chart">
                <canvas id="company-product-chart" width="1200" height="400"></canvas>
              </div>
            </div>
          </div>
        </div>

      </b-tab>
    </b-tabs>

    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="selectProductModal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onSelectProductOk"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VueHtmlToPaper from 'vue-html-to-paper';


  export default {
    name: "allcompanyproducts",
    created: () => {
    },
    components: {
      VsTable,
      Products,
    },
    data() {
      return {
        show: true,
        nodata: true,
        access: {},
        product: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],


      };
    },
    beforeMount() {
      this.getAllRawProductsQuantity();
      Chart.defaults.global.defaultFontFamily = 'shabnam';
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
    },
    methods: {
      onPrintClicked() {
        const title = document.title;
        document.title = "گزارش موجودی کالا در کل شرکت : " + this.productName;
        this.$htmlToPaper('printMe');
        document.title = title;
      },
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();

        if (this.$refs && this.$refs.selectProductModal) {


          this.$refs.selectProductModal.show();
        }
        _products.$on("onRowSelect", row => {
          // this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      onSelectProductOk(row) {
        this.hideModal();
      },
      openProductDetailModal(prod) {
        this.productName = prod.productName;
        this.unitName = prod.unit.unitValue;
        this.productId = prod.id;
        this.hideModal();
        this.getAllProductsQuantity(prod.id)

      },
      getAllProductsQuantity(id) {
        new BaseService('Planning', '/GetAllProductsQuantity/' + id).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.productQuantity = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getAllRawProductsQuantity() {
        new BaseService('Planning', '/GetAllRawProductsQuantity').getList().then((response) => {
          this.rawproductQuantity = response.data;
          let lables = [];
          let companyData = [];
          let orderData = [];
          let index = 0;
          for (let i = 0; i < this.rawproductQuantity.length; i++) {

            lables.push(this.rawproductQuantity[i].name);
            if (this.rawproductQuantity[i].companyQuantitys !== null) {
              for (let j = 0; j < this.rawproductQuantity[i].companyQuantitys.length; j++) {
                if (!companyData.includes(this.rawproductQuantity[i].companyQuantitys[j].companyName)) {
                  companyData.push(this.rawproductQuantity[i].companyQuantitys[j].companyName);
                }
              }
            }
          }

          for (let c = 0; c < companyData.length; c++) {
            let countData = [];
            for (let i = 0; i < this.rawproductQuantity.length; i++) {
              if (this.rawproductQuantity[i].companyQuantitys !== null) {
                let find = false;
                let iii = 0;
                for (let j = 0; j < this.rawproductQuantity[i].companyQuantitys.length; j++) {
                  if (companyData[c] == this.rawproductQuantity[i].companyQuantitys[j].companyName) {
                    find = true;
                    iii = j;
                    break;
                  }
                }
                if (find) {
                  countData.push(this.rawproductQuantity[i].companyQuantitys[iii].quantity);
                } else {
                  countData.push(0);
                }
              } else {
                countData.push(0);
              }
            }
            let data = {
              label: companyData[c],
              backgroundColor: this.backgroundColor[index],
              hoverBackgroundColor: this.hoverBackgroundColor[index],
              data: countData
            };

            orderData.push(data);
            index++;
            if (index > 5) index = 0;
          }

          this.polar = new Chart(document.getElementById("product-company-chart"), {


            // type: 'polarArea',
            type: 'bar',
            data: {
              labels: lables,
              datasets: orderData
            },
            options: {
              scales: {
                xAxes: [{
                  stacked: true,

                }],
                yAxes: [{
                  stacked: true,

                }]
              },
              title: {
                display: true,
                text: 'موجودی به تفکیک کارگاه'
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
            }
          })

          orderData = [];
          for (let i = 0; i < this.rawproductQuantity.length; i++) {
            let countData = [];
            if (this.rawproductQuantity[i].companyQuantitys !== null) {
              for (let j = 0; j < this.rawproductQuantity[i].companyQuantitys.length; j++) {
                let find = false;
                for (let c = 0; c < companyData.length; c++) {
                  if (companyData[c] == this.rawproductQuantity[i].companyQuantitys[j].companyName) {
                    find = true;
                    break;
                  }
                }
                if (find) {
                  countData.push(this.rawproductQuantity[i].companyQuantitys[j].quantity);
                } else {
                  countData.push(0);
                }
              }
            } else {
              countData.push(0);
            }
            let data = {
              label: this.rawproductQuantity[i].name,
              backgroundColor: this.backgroundColor[index],
              hoverBackgroundColor: this.hoverBackgroundColor[index],
              data: countData
            };

            orderData.push(data);
            index++;
            if (index > 5) index = 0;
          }

          this.polar = new Chart(document.getElementById("company-product-chart"), {


            // type: 'polarArea',
            type: 'bar',
            data: {
              labels: companyData,
              datasets: orderData
            },
            options: {
              scales: {
                xAxes: [{
                  stacked: true,

                }],
                yAxes: [{
                  stacked: true,

                }]
              },
              title: {
                display: true,
                text: 'موجودی به تفکیک کالا'
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
            }
          })


        }).catch((error) => {
          console.log(error)
        });
      },


    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
